import type {
  OpportunityApiStep,
  OpportunityResponseDto,
} from '../../features/opportunities/opportunity.mapper';

type MockMaterialChangeKind = 'document' | 'documentRemoved' | 'metadata' | 'scotsman';

const STEP_ORDER: Record<OpportunityApiStep, number> = {
  UploadAndStart: 0,
  SmartDiscovery: 1,
  Scotsman: 2,
  OpportunityMetadata: 3,
  OpportunityAssessment: 4,
};

let opportunitiesRef: OpportunityResponseDto[] | null = null;

/** Binds mock opportunity list for wizard rewind updates from qualification handlers. */
export function mockQualificationBindOpportunities(opportunities: OpportunityResponseDto[]): void {
  opportunitiesRef = opportunities;
}

function rewindApiStep(kind: MockMaterialChangeKind): OpportunityApiStep {
  switch (kind) {
    case 'document':
      return 'SmartDiscovery';
    case 'documentRemoved':
      return 'UploadAndStart';
    case 'metadata':
      return 'OpportunityMetadata';
    case 'scotsman':
      return 'Scotsman';
  }
}

export function mockApplyQualificationMaterialChange(
  opp: OpportunityResponseDto,
  kind: MockMaterialChangeKind,
): OpportunityResponseDto {
  const target = rewindApiStep(kind);
  const currentStep = (opp.step ?? 'UploadAndStart') as OpportunityApiStep;
  const step = STEP_ORDER[currentStep] > STEP_ORDER[target] ? target : currentStep;
  return {
    ...opp,
    step,
    updatedAt: new Date().toISOString(),
  };
}

export function mockQualificationMaterialChangeById(
  opportunityId: string,
  kind: MockMaterialChangeKind,
): void {
  if (!opportunitiesRef) {
    return;
  }
  const index = opportunitiesRef.findIndex((row) => row.id === opportunityId);
  if (index < 0) {
    return;
  }
  opportunitiesRef[index] = mockApplyQualificationMaterialChange(opportunitiesRef[index], kind);
}

const METADATA_PATCH_KEYS: (keyof OpportunityResponseDto)[] = [
  'isFrameContract',
  'tcvLocal',
  'tcv',
  'bidBudget',
  'accountPotential',
  'existingRelationship',
];

export function mockPatchHasQualificationMetadataChange(
  existing: OpportunityResponseDto,
  patch: Partial<OpportunityResponseDto>,
): boolean {
  return METADATA_PATCH_KEYS.some((key) => {
    if (patch[key] === undefined) {
      return false;
    }
    return patch[key] !== existing[key];
  });
}
